import React, { useState } from 'react';

import './chips-desktop.scss';

interface TabsProps {
    defaultValue: string;
    tabs: { title: string; key: string; items: { url: string; name: string; }[]; }[];
}

const ChipsDesktop: React.FC<TabsProps> = props => {
    const [activeTab, setActiveTab] = useState(props.defaultValue);

    const click = (tab: string): void => {
        setActiveTab(tab);
    };

    return (
        <div className="chips-tabs">
            <div className="chips-tabs__row">
                <div className="chips-tabs__navi">
                    {props.tabs.map(tab => (
                        <button
                            type="button"
                            className={`chips-tabs__navi-tab ${tab.key === activeTab ? 'chips-tabs__navi-tab--active' : ''}`}
                            key={tab.key}
                            title={tab.title}
                            onClick={(): void => click(tab.key)}
                        >
                            <h3>
                                {tab.title}
                            </h3>
                        </button>
                    ))}
                </div>

                <div className="chips-tabs__content">
                    {props.tabs.map(tab => (
                        <ul
                            className={`chips-tabs__content-tab ${tab.key === activeTab ? 'chips-tabs__content-tab--active' : ''}`}
                            key={`${tab.key}content`}
                        >
                            {tab.items.map((item, index) => (
                                <li key={`${tab.key}${index}li`}>
                                    <a href={item.url} title={item.name}>
                                        {item.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ChipsDesktop;
